import api from "@/lib/api";

// One small, cookie-free hit per page view. The visitor id is the same random browser id the
// site already uses for security (no names, emails or card data are ever sent).
function id(store, key) {
    try {
        let v = store.getItem(key);
        if (!v) {
            v = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID()
                : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
            store.setItem(key, v);
        }
        return v;
    } catch { return ""; }
}

let firstHit = true;

export function trackPage(pathname) {
    if (!pathname || pathname.startsWith("/admin")) return;
    try {
        const q = new URLSearchParams(window.location.search);
        const utm = (k) => q.get(k) || (() => { try { return sessionStorage.getItem(`g2c_${k}`); } catch { return null; } })();
        ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => { if (q.get(k)) { try { sessionStorage.setItem(`g2c_${k}`, q.get(k)); } catch { /* ignore */ } } });
        const body = {
            p: pathname,
            r: firstHit ? document.referrer || "" : "",   // where they came from, on the first page only
            vid: id(localStorage, "g2c_device"),
            sid: id(sessionStorage, "g2c_session"),
            us: utm("utm_source"), um: utm("utm_medium"), uc: utm("utm_campaign"),
            w: window.innerWidth,
        };
        firstHit = false;
        api.post("/t/hit", body).catch(() => {});
    } catch { /* never break the page for analytics */ }
}
